// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBarHeader_wrapper__AhAUp"};